export const OrderStatus = [
    {label: "New", value: 1},
    {label: "In Processing", value: 2},
    {label: "Done", value: 3},
]